import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TranslateService, TranslationObject } from '@ngx-translate/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map, switchMap, take, tap } from 'rxjs/operators';
import { LANGUAGES, LanguageService } from '../language/language.service';

const loadedPages = new Set<string>();

export function pageTranslationsResolver(pagePath: string): ResolveFn<void> {
  return () => {
    if (loadedPages.has(pagePath)) return of(undefined);

    const http = inject(HttpClient);
    const translate = inject(TranslateService);
    const currentLang = inject(LanguageService).current();

    // translate.use() je idempotent - odmah emituje ako su prevodi već učitani
    return translate.use(currentLang).pipe(
      take(1),
      switchMap(() => {
        const requests: Observable<TranslationObject | null>[] = LANGUAGES.map(({ code }) =>
          http.get<TranslationObject>(`/i18n/pages/${pagePath}/${code}.json`).pipe(
            tap(translations => translate.setTranslation(code, translations, true)),
            catchError(() => of(null)),
          ),
        );

        return forkJoin(requests);
      }),
      tap(() => loadedPages.add(pagePath)),
      map(() => undefined),
    );
  };
}
